import { render, staticRenderFns } from "./SummaryPayment.vue?vue&type=template&id=f28ce10c&scoped=true&"
import script from "./SummaryPayment.vue?vue&type=script&lang=js&"
export * from "./SummaryPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28ce10c",
  null
  
)

export default component.exports